export const Header = (headerElement: HTMLDivElement) => {
  const sensor = document.querySelector('.header-sensor');
  if (headerElement && sensor) {
    const observer = new IntersectionObserver(
      ([e]) => headerElement.classList.toggle('is-pinned', e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(sensor);
  }
};

export default Header;
